/// <amd-module name="DistributedTaskUI/SecurityComponent/ProjectPermissionsAuthorization/Actions/ProjectAuthorizationActionsHub" />
import { Action } from "VSS/Reflux/Action";
import * as ServiceEndpoint from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";
import { TeamProjectReference } from "Tfs/Platform/Contracts/Core";

export class ProjectAuthorizationActionsHub {
    getAllProjectsData: any;
    constructor() {
        this.inititlaize();
    }

    public inititlaize(): void {
        this._serviceEndPoint = new Action<ServiceEndpoint.ServiceEndpoint>();
        this._allProjects = new Action<TeamProjectReference[]>();
        this._setErrorMessage = new Action<string>();
    }

    public get getServiceEndpointDetails(): Action<ServiceEndpoint.ServiceEndpoint> {
        return this._serviceEndPoint;
    }

    public get getProjectsData(): Action<TeamProjectReference[]> {
        return this._allProjects;
    }

    public get setErrorMessage(): Action<string> {
        return this._setErrorMessage;
    }

    private _serviceEndPoint: Action<ServiceEndpoint.ServiceEndpoint>;
    private _allProjects: Action<TeamProjectReference[]>;
    private _setErrorMessage: Action<string>;
}
